import React, { Component, PropTypes } from 'react';
import Helmet from 'react-helmet';
import { push } from 'redux-router';
import { filter, isArray, isEqual, uniqueId } from 'lodash';
import { accountRoute, editorialRoute } from '../../routes';

import axios from 'axios';
import qs from 'qs';
import baseUrl from '../../utils/baseUrl';

import connect from '../../utils/connect';

// import Splitter from './block/splitter';
import ContentBlock from './block/content';
// import SubmitBlock from './block/submit';
import ConfirmDialog from '../form/confirm';
import Spinner from '../svg/spinner';

import Form from '../form/form';
import InputText from '../form/input/text';
import InputSubmit from '../form/input/submit';
import InputTextarea from '../form/input/textarea';
import InputDropzone from '../form/dropzone/dropzone';
import InputDropzoneVideo from '../form/dropzone/dropzoneVideo';
import InputWysiwyg from '../form/wysiwyg/wysiwyg';
import Label from '../form/label';

import { dispatchError, dispatchMsg } from '../../actions/errors';

import {
	EDITORIAL_TYPE_QA,
	EDITORIAL_TYPE_ARTICLE,
} from '../../constants/types';

import { redirectToAccountIfNoProfile } from '../../utils/authorization';

// import translate from '../../utils/translate';

import { editEditorial } from '../../actions/editorials';

class AccountEditorialEdit extends Component {
	static propTypes = {
		dispatch: PropTypes.func.isRequired,
		users: PropTypes.object.isRequired,
		browser: PropTypes.object.isRequired,
		params: PropTypes.shape({
			id: PropTypes.string,
			type: PropTypes.string,
		}),
		editorials: PropTypes.shape({
			edit: PropTypes.object.isRequired,
		}).isRequired,
	};

	static contextTypes = {
		router: PropTypes.object
	};

	constructor(props, context) {
		super(props, context);

		this.mounted = true;
		this.routerWillLeave = this.routerWillLeave.bind(this);
		this.windowWillLeave = this.windowWillLeave.bind(this);

		this.state = {
			waiting: true,
			id: (props.params && props.params.id) ? props.params.id : false,
			type: (props.params && props.params.type) ? props.params.type : false,
			extraVisuals: this.getVisualsFromEditorial(props.editorials.edit.editorials),
			extraLinks: this.getLinksFromEditorial(props.editorials.edit.editorials),
			saved: false,
			busySaving: false,
		};
	}

	componentWillMount() {
		this.isProfile() && redirectToAccountIfNoProfile(this.props.dispatch, this.props.users);

		if (this.state.type) {
			this.props.dispatch(editEditorial(this.state.type, this.state.id));
		} else {
			// @TODO redirect -- what are you doing here?
		}

		if (this.context.router) {
			// console.log('setRouteLeaveHook');
			// console.log(this.props.route);
			this.removeRouteHook = this.context.router.setRouteLeaveHook(this.props.route, this.routerWillLeave);
		}

		window.onbeforeunload = this.windowWillLeave;
	}

	componentDidMount() {
		this.setContentHash();

		if (
			this.props.editorials.edit &&
			this.props.editorials.edit.editorials &&
			this.props.editorials.edit.editorials.status === 'IN_REVIEW'
		) {
			const basePath = this.isProfile() ? '/profile/editorial/' : '/editorial/';
			this.props.dispatch(push(accountRoute(`${basePath}${this.state.type}`)));
		}
	}

	componentWillUnmount() {
		this.mounted = false;
		window.removeEventListener('beforeunload', this.windowWillLeave);
		if (typeof this.removeRouteHook === 'function') {
			this.removeRouteHook();
		}
	}

	windowWillLeave(e) {
		const hasUnsavedChanges = !this.isSaved();
		return hasUnsavedChanges ? 'You have unsaved changes, are you sure you want to leave?' : null;
	}

	routerWillLeave(e) {
		// console.log(e);
		const hasUnsavedChanges = !this.isSaved();
		// console.log('hasUnsavedChanges:', hasUnsavedChanges);

		if (this.actuallyLeave || !hasUnsavedChanges) {
			// return true; -- continue to end
		} else {
			if (this.refs.confirm) {
				this.refs.confirm
				.confirm('You have unsaved changes, are you sure you want to leave?', 'Yes')
				.then(() => {
					this.actuallyLeave = true;

					switch (e.action) {
						case 'PUSH':
							this.props.dispatch(push(e.pathname));
							break;
						case 'POP':
							window.history.back();
							break;
						default:
							window.location.href = e.pathname;
					}
				})
				.catch(() => {});

				return false;
			}
		}

		return true;
	}

	componentWillReceiveProps(nextProps) {
		if (
			nextProps.editorials.edit &&
			nextProps.editorials.edit.editorials &&
			nextProps.editorials.edit.editorials.status === 'IN_REVIEW'
		) {
			const basePath = this.isProfile() ? '/profile/editorial/' : '/editorial/';
			this.props.dispatch(push(accountRoute(`${basePath}${this.state.type}`)));
		}

		if (nextProps.editorials.edit && nextProps.editorials.edit.editorialId) {
			let extraVisuals = this.state.extraVisuals;

			if (
				nextProps.editorials.edit.editorials &&
				nextProps.editorials.edit.editorials.sections
			) {

				if (
					this.props.editorials.edit.editorials === undefined ||
					(
						this.props.editorials.edit.editorials &&
						nextProps.editorials.edit.editorials.sections !== this.props.editorials.edit.editorials.sections
					)
				) {
					extraVisuals = this.getVisualsFromEditorial(nextProps.editorials.edit.editorials);
				}
			}

			this.mounted && this.setState({
				...this.state,
				waiting: false,
				id: nextProps.editorials.edit.editorialId,
				extraVisuals,
				extraLinks: this.getLinksFromEditorial(nextProps.editorials.edit.editorials),
			});
		}

		setTimeout(() => {
			this.setContentHash();
		}, 100);
	}

	render() {
		if (this.state.waiting) {
			return this.renderWaiting();
		}

		return (
			<div className='account-editorial'>
				<Helmet title='The FWA - Editorial Edit' />
				<ConfirmDialog ref='confirm' />
				<Form getRefs={() => this.getRefs()} method='put' action='' ref='form'>
					<ContentBlock title={this.props.editorials.edit.editorials.title} sticky browser={this.props.browser}>
						<div className='account-block-content__content__buttons'>
							<InputSubmit name='Save' className='button button--dark' onClick={(e) => { e.preventDefault();this.saveEditorial(false); }} waiting={this.state.busySaving} />
							<InputSubmit name='Save & Preview' className='button button--dark' onClick={(e) => { e.preventDefault();this.getPreview(); }} />
							<InputSubmit name='Ready to Publish' className='button button--dark' onClick={(e) => { e.preventDefault();this.saveEditorial(true); }} />
						</div>
					</ContentBlock>

					<ContentBlock title={'Top Image'}>
						<Label btw={'1364 · 620 jpg / png'} />
						<InputDropzone
							ref='hero'
							aspect={(620 / 1364)}
							width={354}
							path={`${baseUrl}/api/account/editorials/form/image`}
							params={{ editorialId: this.state.id }}
							inputs={[
								{ name: 'hero', preview: this.props.editorials.edit.editorials.image },
							]}
							accept='image/*'
							disableDelete
						/>
					</ContentBlock>

					{((this.props.editorials.edit.layoutType === EDITORIAL_TYPE_QA) && this.renderQAFields())}

					{((this.props.editorials.edit.layoutType === EDITORIAL_TYPE_ARTICLE) && this.renderArticleHeadlineFields())}
					{((this.props.editorials.edit.layoutType === EDITORIAL_TYPE_ARTICLE) && this.renderArticleBodyFields())}

					<ContentBlock title={'Extra visuals'}>
						<Label
							label=''
							btw={
								<span>
									Add at least 4 visuals that add or in some way relate to the interview/article.
									<br />
									Min. 430 pixels wide, max. 800 high.
								</span>
							}
						/>
						<div className='account-block-content__extravisual'>
							{this.state.extraVisuals.map((item) => (
								<InputDropzoneVideo
									key={item.id || item.name}
									ref={item.name}
									name={item.name}
									preview={item.preview}
									video={item.video}
									mode={item.mode}
									aspect={0.638888889}
									caption={item.caption}
									width={354}
									params={{
										editorialId: this.state.id,
										sectionId: item.id,
									}}
									path={'/api/account/profiles/editorials/interview/form/image'}
									accept='image/*'
									extraValue={{
										id: item.id,
										fid: item.fid,
									}}
									changeId={(newId, path) => this.changeVisualId(item, newId, path)}
								/>
							))}
						</div>

					</ContentBlock>

					<ContentBlock className='pixel-pattern pixel-pattern--01'>
						<button className='button button--dark button--no-margin' onClick={(e) => this.addVisuals(e)}>Add more visuals</button>
					</ContentBlock>

					<ContentBlock title='Links'>
						<div>
							{this.state.extraLinks.map((item, i) => {
								let idName = `${item.name}[id]`;
								let titleName = `${item.name}[title]`;
								let urlName = `${item.name}[url]`;

								return (
									<div key={item.name} className='span3 cf account-block-content__extralink'>
										<InputText type='hidden' ref={idName} name={idName} value={item.id || uniqueId('new_')} />

										<span />

										<InputText
											type='text'
											ref={titleName}
											name={titleName}
											placeholder='Link name (as shown to the reader)'
											className='account-block-content__extralink__text'
											label={`Link ${(i + 1)}`}
											btw=' (optional)'
											value={item.title}
										/>

										<span />

										<InputText
											type='url'
											ref={urlName}
											name={urlName}
											placeholder='Add URL'
											className='account-block-content__extralink__url'
											value={item.link}
										/>
									</div>
								);
							})}
						</div>
					</ContentBlock>

					<ContentBlock className='pixel-pattern pixel-pattern--01'>
						<button className='button button--dark button--no-margin' onClick={(e) => this.addLinks(e)}>Add more links</button>
					</ContentBlock>

					{/*

						<ContentBlock title={'Tagselect'}>
							<InputTagSelect ref='tagselect' name='tagselect' placeholder='Type to search for FWA Profiles'  onChange={(e) => {}}></InputTagSelect>
						</ContentBlock>

						<ContentBlock className='pixel-pattern pixel-pattern--01'>

						</ContentBlock>

						<ContentBlock title={'Dropzone grid'}>
							<InputDropzoneGrid
								ref='dropgrid'
								name='dropgrid'
								aspect={0.638888889}
								path={'/api/account/profiles/editorials/interview/form/image'}
								inputs={[
									{ name: 'foo', preview: '' },
									{ name: 'bar', preview: '' },
									{ name: 'baz', preview: '' },
								]}
								accept='image/*' />
						</ContentBlock>

						*/}

				</Form>
			</div>
		);
	}

	changeVisualId(item, newId, path) {
		// console.log(item, newId);
		const newExtraVisuals = [
			...this.state.extraVisuals,
		];

		if (item.id || item.fid) {
			const idToFind = item.id || item.fid;
			const idOrFid = (!item.id && item.fid) ? 'fid' : 'id';

			for (let i = 0; i < newExtraVisuals.length; i++) {
				if (newExtraVisuals[i][idOrFid] === idToFind) {
					let shouldNotClear = !!path;
					newExtraVisuals[i] = {
						...newExtraVisuals[i],
						id: shouldNotClear ? parseInt(newId, 10) : uniqueId('new_'),
						mode: shouldNotClear ? 'IMAGE' : 'NEUTRAL',
						preview: shouldNotClear ? path : '',
						caption: shouldNotClear ? item.caption : '',
					};
				}
			}
		}

		// console.table(newExtraVisuals);

		this.setState({
			...this.state,
			extraVisuals: newExtraVisuals,
		});
	}

	getQAContent(editorial) {
		const QAArray = [];
		const contents = editorial.contents;

		for (let i = 0; i < contents.length; i++) {
			if (contents[i].type === 'editorial-qa') {
				QAArray.push({
					id: contents[i].id,
					q: contents[i].question,
					a: contents[i].answer,
				});
			}
		}

		return QAArray;
	}

	renderQAFields() {
		const questions = this.getQAContent(this.props.editorials.edit.editorials);

		return (
			<ContentBlock title={'Q/A'}>
				{questions.map((question, i) => {
					let name = `answer[${(question.id || i)}]`;
					return (
						<div key={name} className='account-block-content__question'>
							<div className='account-block-content__question__q'>
								{question.q}
							</div>

							<InputWysiwyg ref={name} name={name} value={question.a} placeholder='Answer' className='span5 span8-tablet span100p-mobile' />
						</div>
					);
				})}
			</ContentBlock>
		);
	}

	renderArticleHeadlineFields() {
		return (
			<ContentBlock title={'Headlines'}>
				<div className='span7 span100p-mobile'>
					<InputTextarea
						type='text'
						ref='title'
						name='title'
						placeholder='Headline'
						rows={2}
						label='Headline'
						className='custom-input__textarea--large-type'
						value={this.props.editorials.edit.editorials.title || ''}
						autosize
					/>

					<InputTextarea
						type='text'
						ref='subtitle'
						name='subtitle'
						placeholder='Site of the Day, 12th June 2015'
						rows={2}
						label='Sub headline'
						className='custom-input__textarea--large-type'
						value={this.props.editorials.edit.editorials.subtitle || ''}
						autosize
					/>

					<InputTextarea
						type='text'
						ref='excerpt'
						name='excerpt'
						placeholder='An excerpt for the article'
						rows={4}
						label='Excerpt'
						className='custom-input__textarea--medium-type'
						value={this.props.editorials.edit.editorials.excerpt || ''}
						autosize
					/>
				</div>
			</ContentBlock>
		);
	}

	renderArticleBodyFields() {
		return (
			<ContentBlock title={'Body copy'}>
				<Label name='content' label='Article' />
				<InputWysiwyg
					ref='content'
					name='content'
					value={this.getContents()}
					placeholder='...'
					className='span5 span8-tablet span100p-mobile form-wysiwyg--large'
				/>
			</ContentBlock>
		);
	}

	getVisualsFromEditorial(editorial) {
		if (!editorial) {
			return [];
		}

		// transform into usable format
		const visualsArray = ((sidebarSections) => {
			const vsls = [];
			for (let i = 0; i < sidebarSections.length; i++) {
				const preview = (sidebarSections[i].image) ? sidebarSections[i].image : '';

				const video = ((sect) => {
					switch (sect.type) {
						case 'YOUTUBE':
							return sect.youtube;
						case 'VIMEO':
							return sect.vimeo;
						default:
							return false;
					}
				})(sidebarSections[i]);

				vsls.push({
					id: sidebarSections[i].id,
					name: `visuals[${vsls.length}]`,
					mode: sidebarSections[i].type ? sidebarSections[i].type : 'NEUTRAL',
					caption: sidebarSections[i].description || '',
					video,
					preview,
				});
			}

			return vsls;
		})(filter(editorial.sections, (o) => (o.type === 'IMAGE' || o.type === 'YOUTUBE' || o.type === 'VIMEO')));

		while (visualsArray.length < 4) {
			const itemId = uniqueId('new_');
			visualsArray.push({
				id: itemId,
				name: `visuals[${visualsArray.length}]`,
				preview: '',
			});
		}

		return visualsArray;
	}

	getLinksFromEditorial(editorial) {
		if (!editorial) {
			return [];
		}

		// transform into usable format
		const linksArray = ((links) => {
			const lnks = [];
			for (let i = 0; i < links.length; i++) {
				lnks.push({
					id: links[i].id,
					name: `link[${lnks.length}]`,
					link: links[i].link,
					title: links[i].link_name,
				});
			}

			return lnks;
		})(filter(editorial.sections, (o) => (o.type === 'LINK')));

		if (!linksArray.length) {
			const itemId = uniqueId('new_');
			linksArray.push({
				id: itemId,
				name: 'link[0]',
				link: '',
				title: '',
			});
		}

		return linksArray;
	}

	getContents() {
		let content = '';
		const contents = (
			this.props.editorials.edit &&
			this.props.editorials.edit.editorials &&
			this.props.editorials.edit.editorials.contents &&
			isArray(this.props.editorials.edit.editorials.contents)
		) ? this.props.editorials.edit.editorials.contents : [];

		for (let i = 0; i < contents.length; i++) {
			content += contents[i].text;
		}

		return content;
	}

	getRefs() {
		return this.refs;
	}

	isProfile(props = false) {
		const theProps = props || this.props;
		return (
			theProps.router &&
			theProps.router.routes &&
			theProps.router.routes[3] &&
			theProps.router.routes[3].source === 'profile');
	}

	setWaiting(state) {
		this.mounted && this.setState({ ...this.state, waiting: state });
	}

	setContentHash() {
		if (this.refs && this.refs.form) {
			this.hash = this.refs.form.serialize();
		} else {
			this.hash = false;
		}
		// console.log('SETTING HASH: ', this.hash);
	}

	isSaved() {
		if (this.refs && this.refs.form) {
			// console.log('COMPARING::');
			// console.dir(this.hash);
			// console.dir(this.refs.form.serialize());
			// console.log('EQUAL: ', isEqual(this.hash, this.refs.form.serialize()));

			return isEqual(this.hash, this.refs.form.serialize());
		}

		return true;
	}

	renderWaiting() {
		return (
			<div key='spinner' style={{ textAlign: 'center', width: '100%', marginTop: '50px' }}>
				<Spinner size='60' />
			</div>
		);
	}

	addVisuals(e) {
		e.preventDefault();

		const extraVisuals = [
			...this.state.extraVisuals,
		];

		extraVisuals.push({
			fid: uniqueId('new_'),
			name: `visuals[${extraVisuals.length}]`,
			preview: '',
		});

		this.mounted && this.setState({
			...this.state,
			extraVisuals,
		});
	}

	addLinks(e) {
		e.preventDefault();

		const extraLinks = [
			...this.state.extraLinks,
		];

		extraLinks.push({
			id: uniqueId('new_'),
			name: `link[${extraLinks.length}]`,
			title: '',
			link: '',
		});

		this.mounted && this.setState({
			...this.state,
			extraLinks,
		});
	}

	setBusySaving(val = false) {
		this.mounted && this.setState({
			...this.state,
			busySaving: val,
		});
	}

	isProfile(props = false) {
		props = props || this.props;
		return (
			this.props.router &&
			this.props.router.routes &&
			this.props.router.routes[3] &&
			this.props.router.routes[3].source === 'profile');
	}

	saveEditorial(isFinal) {
		const data = {
			id: this.state.id,
			draft: !isFinal ? 1 : 0,
			...this.refs.form.serialize(),
		};

		this.setBusySaving(true);

		// console.table(data);

		return axios.put(`${baseUrl}/api/account/editorials/${this.state.type}/form`, qs.stringify(data))
		.then((res) => {
			this.setContentHash();
			this.setBusySaving(false);

			if (res.data && res.data.message) {
				this.props.dispatch(dispatchMsg(res.data));
			}

			if (isFinal) {
				const basePath = this.isProfile() ? '/profile/editorial/' : '/editorial/';
				this.setContentHash();
				this.props.dispatch(push(accountRoute(`${basePath}${this.state.type}`)));
			} else {
				this.props.dispatch(editEditorial(this.state.type, this.state.id));
			}
		})
		.catch((res) => {
			if (res.data && res.data.message) {
				this.props.dispatch(dispatchError(res.data));
			}

			this.setBusySaving(false);
		});
	}

	getPreview() {
		const data = {
			id: this.state.id,
			draft: 1,
			...this.refs.form.serialize(),
		};

		this.refs.confirm
		.confirm('Saving preview...', false, false);

		return axios.put(`${baseUrl}/api/account/editorials/${this.state.type}/form`, qs.stringify(data))
		.then((res) => {
			this.props.dispatch(editEditorial(this.state.type, this.state.id));
			this.setContentHash();

			this.refs.confirm
			.confirm('Preview is ready', 'Open preview', false, `${editorialRoute(res.data.slug)}?preview=${res.data.previewHash}`)
			.then(() => {
				// if (res.data && res.data.previewHash && res.data.slug) {
				// 	window.open(`${editorialRoute(res.data.slug)}?preview=${res.data.previewHash}`);
				// }
			})
			.catch(() => {});
		})
		.catch((res) => {
			let text = 'Generating preview failed';

			if (res.data) {
				if (res.data.message) {
					text = res.data.message;
				}

				if (res.data.errors) {
					const errors = res.data.errors;
					const errorKeys = Object.keys(errors);
					for (let i = 0; i < errorKeys.length; i++) {
						text += `\n${errors[errorKeys[i]]}`;
					}
				}
			}

			this.refs.confirm
			.confirm(text, false);
		});
	}
}

export default connect(AccountEditorialEdit);



/** WEBPACK FOOTER **
 ** ./frontend/components/account/editorialEdit.js
 **/